import type { ChangeEvent } from "react";

interface EditableTextProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  label: string;
  multiline?: boolean;
  rows?: number;
}

export function EditableText({
  value,
  onChange,
  className = "",
  label,
  multiline = false,
  rows = 3
}: EditableTextProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    onChange(event.target.value);

  if (multiline) {
    return (
      <textarea
        aria-label={label}
        className={`editable-field editable-field--multiline ${className}`}
        value={value}
        rows={rows}
        onChange={handleChange}
      />
    );
  }

  return (
    <input
      aria-label={label}
      className={`editable-field ${className}`}
      value={value}
      onChange={handleChange}
    />
  );
}

interface IconButtonProps {
  label: string;
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
  className?: string;
}

export function IconButton({
  label,
  children,
  onClick,
  disabled = false,
  active = false,
  className = ""
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={`icon-button ${active ? "is-active" : ""} ${className}`}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
